/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Volver',
    CANCEL: 'Cancelar',
    CLOSE: 'Cerrar',
    COLLECT: 'Recoger',
    CONFIRM: 'Confirmar',
    NEW_USER: 'Nuevo usuario',
    NEXT: 'Siguiente',
    SAVE: 'Guardar',
    SCAN_QR_CODE: 'Escanear el código QR',
    SWIPE_DOWN: 'Deslizar hacia abajo para ocultar los detalles',
    SWIPE_UP: 'Deslizar hacia arriba para ver los detalles',
    WITHOUT_PIN: '¿No tienes un PIN o código QR? {link}',
    WITHOUT_PIN_TO_COLLECT: '¿No tienes un PIN? {link}'
  },
  ERRORS: {
    INVALID_CODE: 'Código no válido.',
    INVALID_EMAIL: 'Correo electrónico no válido.',
    INVALID_NUMBER: 'Número no válido.',
    INVALID_PHONE: 'Número de teléfono no válido.',
    INVALID_USER: 'Usuario no válido.',
    ORDER_DELIVER_INVALID_CODE: '{code} no válido.',
    ORDER_DELIVERED: 'El pedido ya se ha entregado.',
    SOMETHING_WENT_WRONG: '¡Se ha producido un error!',
    UNABLE_TO_VALIDATE: 'No se ha podido validar el pedido.',
    VALIDATING_CODE: 'No se ha podido validar el código {code}.'
  },
  LABELS: {
    ACCEPT_RETURN: '¿Está seguro de que desea aceptar la devolución?',
    ALL_ORDERS: 'Ver todo',
    ANOMALY: '¿Anomalías?',
    CANCELED: 'Cancelado',
    CLICK_HERE: 'Haz clic aquí',
    CLIENT_NAME: 'Cliente',
    COLLECT_ORDER: 'Devolver pedido',
    COLLECTS_NOT_FOUND: 'No hay recogidas.',
    CUSTOMER_SIGNATURE: 'Firma del cliente',
    DATE_AND_HOUR: 'Fecha y hora',
    DELIVER_ORDER: 'Entregar pedido',
    DELIVERED: 'Entregado',
    EMAIL: 'Correo electrónico',
    ERROR: 'Error',
    IDENTITY_DOCUMENT: 'Documento de identidad',
    IDENTITY_NAME: 'Nombre en el documento de identidad',
    IDENTITY_NUMBER: 'Número del documento de identidad',
    NAME: 'Nombre',
    NEW_USER: 'Nuevo usuario',
    NO_USERS: 'Todavía no hay usuarios',
    NOT_DELIVERED: 'No entregado',
    OR: 'O',
    ORDER_CODE: 'Código del pedido',
    ORDER_NUMBER: 'Número del pedido',
    PACKAGE_NUMBER: 'Número del paquete',
    PACKAGES: 'Paquetes',
    PACKAGES_CODES: 'Códigos de las cajas',
    PACKAGES_DELIVERED: 'Paquetes entregados',
    PACKAGES_NUMBER: 'Cantidad de paquetes',
    PACKAGES_RECEIVED: 'Paquetes recibidos',
    PHONE: 'Número de teléfono',
    PHONE_EXAMPLE: ', ejemplo: +351999999999',
    PICK_UP_COLLECT_PIN: 'PIN de devolución',
    PICK_UP_NOT_FOUND: 'No se han encontrado puntos de recogida.',
    PICK_UP_PIN: 'Código de recogida',
    PICK_UP_SEARCH: 'Buscar un punto de recogida',
    PICK_UP_SELECT: 'Seleccionar un punto de recogida',
    PROCESSING: 'En procesamiento',
    READ_CLIENT_DELIVERY_QR_CODE: 'Escanear el código QR de recogida',
    READ_PACKAGE_QR_CODE: 'Escanear el código QR del paquete',
    RECEIVE_PACKAGES: 'Recibir paquetes',
    RECEIVED_BY: 'Recibido por',
    RETURNED: 'Devuelto',
    RETURNS: 'Devoluciones',
    SEARCH_FOR: 'Buscar',
    SELECT_DELIVER: 'Selecciona un pedido para entregar',
    SHOW_ALL: 'Todos',
    SHOW_IN_TRANSIT: 'En tránsito',
    SHOW_PENDING: 'Pendientes',
    STATE: 'Estado',
    SUCCESS: 'Correcto',
    TOTAL_ORDERS: 'Pedidos',
    TOTAL_PACKAGES: 'Paquetes',
    TRACKING_NUMBER: 'N.º de seguimiento',
    TYPE: 'Tipo',
    TYPE_COLLECT: 'Pedido de recogida',
    TYPE_DELIVERY: 'Pedido de entrega',
    USERS: 'Usuarios',
    WARNING: 'Aviso',
    YOUR_ID: 'Tu id.: {id}'
  },
  SENTENCES: {
    COLLECT_PACKAGES: 'Caja(s) del pedido {trackingNumber}.',
    DELIVERED_PACKAGES:
      'Se han leído todos los paquetes del pedido {trackingNumber}.',
    HI: '👋 Hola, {name}:',
    NO_DELIVERIES: 'No hay pedidos para entregar.',
    ORDER_TO_RETURN: 'Rellene el PIN del pedido a devolver.',
    RECEIVED_PACKAGES: 'Se han recibido todos los paquetes.',
    UNDELIVERED_PACKAGES:
      'Hay {total} paquete(s) sin leer referente(s) al pedido {trackingNumber}.',
    UNRECEIVED_PACKAGES: 'Hay {total} paquete(s) no recibido(s).',
    WELCOME: 'Te damos la bienvenida. ¿Qué quieres hacer?',
    WELCOME_WITH_PROZIS_POINTS: 'Ya has ganado {prozisPoints} ProzisPoints.',
    WITHOUT_SERVICE_POINTS:
      'Sin puntos de servicio asignados. La aplicación se cerrará.'
  },
  SUCCESS: {
    CODE_READ: 'El código {code} se ha leído correctamente.'
  }
};
